import { CollectionsLobbyEventTypes } from '../types';
import { createUserActionBigQueryEvent } from '../../../../../shared/utils/events/bigQuery/userAction';

const { header, emptyView, collectionCard } = CollectionsLobbyEventTypes;

export const CollectionsLobbyBigQueryEvents = {
    [header.actions.createCollection.clicked]: createUserActionBigQueryEvent('clicked_on_create_list'),

    [emptyView.actions.createCollection.clicked]: createUserActionBigQueryEvent('clicked_on_create_list'),

    [collectionCard.actions.shareWithTeam.clicked]: createUserActionBigQueryEvent('clicked_on_invite_team'),
    [collectionCard.actions.shareWithTeam.clicked]: createUserActionBigQueryEvent('clicked_on_invite_team'),
    [collectionCard.actions.socialShare.clicked]: createUserActionBigQueryEvent('clicked_on_share_link'),
    [collectionCard.actions.edit.clicked]: createUserActionBigQueryEvent('clicked_on_edit_list'),
    [collectionCard.actions.delete.clicked]: createUserActionBigQueryEvent('clicked_on_delete_list'),
};
